//View Keys
export default {
    realtimemaps_unit_selection_unit: 'Unit',
    realtimemaps_unit_selection_address: 'Address',
    realtimemaps_unit_selection_driver: 'Driver',
    realtimemaps_unit_selection_event: 'Event',
    realtimemaps_unit_selection_unitDate: 'Unit Date',
    realtimemaps_unit_selection_exportOfUnits: 'Units',
    realtimemaps_unit_selection_messageTable: 'Using your cursor, draw a shape on the map around the units you want to see details for.',
};